import { useEffect } from "react";
import { Link } from "react-router-dom";
import { setPageMeta } from "@/lib/api";

export default function PaymentCancel() {
  useEffect(() => {
    setPageMeta("Checkout Cancelled | Ninja Run Club", "Checkout cancelled.");
  }, []);
  return (
    <div className="bg-night min-h-[70vh] flex items-center justify-center px-5">
      <div className="border border-white/20 p-10 max-w-lg w-full text-center" data-testid="payment-cancel">
        <p className="font-display text-3xl lg:text-4xl">NO CHARGE. NO PRESSURE.</p>
        <p className="text-white/60 text-sm mt-4">Checkout cancelled. The tee will be there after your next run.</p>
        <Link to="/shop" data-testid="payment-cancel-shop-link" className="btn-invert inline-block mt-8 bg-white text-ink font-mono-label px-6 py-3.5 border border-white hover:bg-transparent hover:text-white">
          BACK TO THE SHOP
        </Link>
      </div>
    </div>
  );
}
